import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import add from "./add.js";
import update from "./update.js";
import init from "./init.js";

export default contract({
  add: array([
    add
  ]),
  init: array([
    init
  ]),
  update: array([
    update
  ])
})